import excelIcon from '@/assets/excel.svg';

export const ExcelIcon = () => <img src={excelIcon} alt="Excel Icon" className="w-4 h-4 mr-2" />;
